import React from 'react';
import type { ProductVariantTileViewModel } from '@rocco/ui/tile-product/view-models/product';
import { darken, meetsContrastGuidelines } from 'polished';
import { cn } from '@rocco/utils/cn';
import { isColourString } from '../../../utils/colour-helpers';

interface ProductTileVariantsProps {
    variants: ProductVariantTileViewModel[];
    limit?: number;
    /** Portrait browse tiles tighten the mobile swatch row; legacy tiles keep the default scale. */
    compact?: boolean;
}

export const ProductTileVariants = (props: ProductTileVariantsProps) => {
    const { variants, limit = 5, compact } = props;
    const colorToCompareWith = '#fafafa';

    return (
        <div className="flex h-7 items-center gap-2.5">
            <div className={cn('flex gap-1.5', compact && 'max-md:gap-1')}>
                {variants.slice(0, limit).map((variant, index) => {
                    const image = variant.image.src;

                    return (
                        <div key={`${variant.color}-${index}`}>
                            <div
                                className="size-3.5 overflow-hidden rounded-full"
                                style={
                                    image
                                        ? {}
                                        : {
                                              backgroundColor:
                                                  !isColourString(
                                                      variant.color,
                                                  ) ||
                                                  meetsContrastGuidelines(
                                                      variant.color,
                                                      colorToCompareWith,
                                                  ).AA
                                                      ? variant.color
                                                      : darken(
                                                            0.2,
                                                            variant.color,
                                                        ),
                                          }
                                }
                            >
                                {image ? (
                                    <img src={image} alt={variant.image.alt} />
                                ) : null}
                            </div>
                        </div>
                    );
                })}
            </div>

            {variants.length > limit && (
                <div
                    className={cn(
                        'text-base leading-none font-medium text-gray-500',
                        compact && 'max-md:text-[0.75rem]',
                    )}
                >
                    (+{variants.length - limit})
                </div>
            )}
        </div>
    );
};
